import { UAParser } from 'ua-parser-js'

export default defineNuxtPlugin((nuxtApp) => {
  if (!process.client) return

  const { initialize, gtag: rawGtag } = useGtag()
  initialize()

  // detect device / os / browser (as before)…
  const parser = new UAParser()
  const { os, browser } = parser.getResult()
  const device = nuxtApp.$device.isMobile
    ? 'mobile'
    : nuxtApp.$device.isTablet
      ? 'tablet'
      : 'desktop'
  const osVer = [os.name, os.version].filter(Boolean).join(' ')
  const browserVer = [browser.name, browser.version].filter(Boolean).join(' ')

  // set user_properties for GA4
  rawGtag('set', {
    user_properties: { device, os: osVer, browser: browserVer }
  })

  // in your plugins/gtag-extended.client.js, replace the wrapper with:
  const bound = rawGtag.bind(window)

  window.gtag = (...args) => {
    // merge in your defaults for events
    if (args[0] === 'event' && typeof args[2] === 'object') {
      args[2] = {
        device,
        os: osVer,
        browser: browserVer,
        ...args[2]
      }
    }

    return bound(...args)
  }

  nuxtApp.vueApp.config.globalProperties.$gtag = window.gtag
  nuxtApp.provide('gtag', window.gtag)
})